var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2188 1.78125L16.0938 1.03125C15.625 0.9375 15.1562 1.15625 14.9688 1.59375L13.5 5C13.3438 5.40625 13.4375 5.875 13.7812 6.125L15.4688 7.5C14.4062 9.6875 12.6562 11.4375 10.4688 12.5L9.09375 10.8125C8.84375 10.4688 8.375 10.375 7.96875 10.5312L4.5625 12C4.15625 12.1875 3.90625 12.6562 4 13.0938L4.75 16.25C4.84375 16.6875 5.21875 17 5.6875 17C13.5625 17 20 10.625 20 2.71875C20 2.25 19.6875 1.875 19.2188 1.78125ZM5.71875 16L5 12.9062L8.34375 11.4688L10.2188 13.75C13.4375 12.2188 15.1875 10.4688 16.7188 7.25L14.4375 5.375L15.875 2.03125L18.9688 2.75C18.9688 10.0625 13.0312 16 5.71875 16Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.11090ef7.svg";
export { ForwardRef as ReactComponent };